import script from "./Drag.vue?vue&type=script&setup=true&lang=js"
export * from "./Drag.vue?vue&type=script&setup=true&lang=js"

import "./Drag.vue?vue&type=style&index=0&id=72a186eb&scoped=true&lang=scss"
import "./Drag.vue?vue&type=style&index=1&id=72a186eb&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72a186eb"]])

export default __exports__